// extracted by mini-css-extract-plugin
module.exports = {"root":"TableHeading_root__7PSv9","clinicsSelect":"TableHeading_clinicsSelect___YPtr"};